import { useCallback } from 'react';

import type { UpdateUnderwriterEmployeeInput } from '../../../../../../graphql';
import {
  useSalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation,
  useSalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation,
} from '../graphql/__generated__';

export function useUpdateUnderwriterEmployee(tenantId?: string) {
  const [updateUnderwriterEmployeeAsCustomer, { error: errorAsCustomer }] =
    useSalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation();
  const [updateUnderwriterEmployeeAsAdmin, { error: errorAsAdmin }] =
    useSalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation();

  const updateUnderwriterEmployee = useCallback(
    async (input: UpdateUnderwriterEmployeeInput) => {
      if (tenantId) {
        return await updateUnderwriterEmployeeAsAdmin({
          variables: {
            input: {
              tenantId,
              ...input,
            },
          },
        });
      } else {
        return await updateUnderwriterEmployeeAsCustomer({
          variables: {
            input,
          },
        });
      }
    },
    [tenantId, updateUnderwriterEmployeeAsAdmin, updateUnderwriterEmployeeAsCustomer]
  );

  return { updateUnderwriterEmployee, error: errorAsCustomer ?? errorAsAdmin };
}
